module.exports = __webpack_public_path__ + "3fc5fed388b32672ca7979af95d8608a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/鸭嘴兽科技二维码.jpg
// module id = 666
// module chunks = 61